import { FC } from 'react';
import React from 'react';
import { ChangeEvent } from 'react';
import Checkbox from './Checkbox.js';
import { Props as CheckboxProps } from './Checkbox.js';

interface Props extends Omit<CheckboxProps, 'onChange'> {
  onChange?: (checked: boolean) => void;
}

export const ControlledCheckbox: FC<Props> = (props) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.currentTarget.checked;
    props.onChange?.(isChecked);
  };
  return <Checkbox {...props} onChange={handleChange} />;
};
